import { FC, ReactNode } from 'react';
import { CustomTagWithIcon, Detail } from './Tag.style';
interface Props {
  icon: ReactNode;
  text: string;
  textColor?: string;
  bgColor: string;
}
const TagWithIconComponent: FC<Props> = ({
  icon,
  text,
  textColor,
  bgColor
}: Props) => {
  return <CustomTagWithIcon color={bgColor} $textColor={textColor}>
            <Detail>
                <div className="icon">{icon}</div>
                <div className="text">{text}</div>
            </Detail>
        </CustomTagWithIcon>;
};
export default TagWithIconComponent;